import { Text } from 'components/Ui-Kits/Text'
import { useSetQuery } from 'hooks/query/useSetQuery'
import { string } from 'prop-types'
import styled from 'styled-components'

export const MainCategory = ({ label, id }) => {
  const setQuery = useSetQuery()

  const goToCategory = () => {
    setQuery({ category: id }, false)
  }

  return (
    <Wrap size={1} bold color="primary" onClick={goToCategory}>
      {label}
    </Wrap>
  )
}

MainCategory.propTypes = {
  label: string,
  id: string,
}

const Wrap = styled(Text)`
  background-color: var(--color-white);
  padding: 0.625rem 1rem;
  cursor: pointer;
  margin: 0;
  text-transform: uppercase;
`
